import React, { useMemo } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { Drawer, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const UrduContentDrawer = ({ drawerOpen, handleCloseDrawer, drawerContent = '', language }) => {
 
  return (
    <Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}>
      <Box sx={{ width: 1200, p: 3, position: 'relative' }}>
        <IconButton
          onClick={handleCloseDrawer}
          sx={{ position: 'absolute', top: 8, right: 8 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" gutterBottom sx={{ pr: 4 }}>
          Full Content
        </Typography>

        <Box
          sx={{
            direction: language?.direction || "RTL",
            fontFamily: "'Jameel Noori Nastaleeq', serif",
            fontSize: '22px',
            lineHeight: '2.0',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          }}
        >
          {parse(drawerContent || '')}
        </Box>
      </Box>
    </Drawer>
  );
};

export default UrduContentDrawer;
